import { gql } from '@apollo/client';

// Query favorite program from favorite content
export const GET_FAVORITE_PROGRAM = gql`
  query GetFavoriteProgram($nextToken: String, $pageSize: Int, $contentType: String) {
    favoriteContent(nextToken: $nextToken, pageSize: $pageSize, contentType: $contentType) {
      items {
        contentV2 {
          ... on Program {
            alternateName
            categories
            imageWide
            name
            tiers
          }
        }
        createdAt
        contentId
        contentType
      }
    }
  }
`;

// Query favorite workout from favorite content api
export const GET_FAVORITE_WORKOUT = gql`
  query GetFavoriteWorkout(
    $nextToken: String
    $pageSize: Int
    $contentType: String
    $contentId: String
  ) {
    favoriteContent(
      nextToken: $nextToken
      pageSize: $pageSize
      contentType: $contentType
      contentId: $contentId
    ) {
      items {
        contentV2 {
          ... on Workout {
            categories
            durationInSeconds
            equipment
            imageWide
            programName
            completionCount
            name
            tiers
          }
        }
        createdAt
        contentId
        contentType
      }
      itemsTotal
      nextToken
    }
  }
`;

// Includes vimeo favorites
export const GET_ALL_FAVORITE_WORKOUTS = gql`
  query GetFavoriteWorkout(
    $nextToken: String
    $pageSize: Int
    $contentType: String
    $syncVimeo: Boolean
  ) {
    favoriteContent(
      nextToken: $nextToken
      pageSize: $pageSize
      contentType: $contentType
      syncVimeo: $syncVimeo
    ) {
      items {
        contentV2 {
          ... on Workout {
            categories
            durationInSeconds
            equipment
            imageWide
            programName
            completionCount
            name
            tiers
          }
        }
        createdAt
        contentId
        contentType
      }
      itemsTotal
      nextToken
    }
  }
`;

// Mutation to add either program or workout to favorite content
export const ADD_FAVORITE_CONTENT = gql`
  mutation AddFavoriteContent($contentId: String!, $contentType: String!) {
    addFavorite(contentId: $contentId, contentType: $contentType)
  }
`;

// Mutation to remove either program or workout from favorite content
export const REMOVE_FAVORITE_CONTENT = gql`
  mutation RemoveFavoriteContent($contentId: String!, $contentType: String!) {
    removeFavorite(contentId: $contentId, contentType: $contentType)
  }
`;

export const IS_FAVORITE_CONTENT = gql`
  query IsFavoriteContent($contentId: String!, $contentType: String!) {
    isFavoriteContent(contentId: $contentId, contentType: $contentType)
  }
`;
